import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { wxAuthLogin, checkAuthStatus } from "@/api/wechat";

const app = createApp(App);
app.use(router);
app.mount("#app");

router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }

  if (to.meta.requiresLogin) {
    const localToken = sessionStorage.getItem("auth_token");
    // 本地有token时先校验有效性，过期会被axios拦截器自动清理
    if (localToken) {
      try {
        const checkAuth = await checkAuthStatus();
        console.log("checkAuth", checkAuth, checkAuth.code);
        if (checkAuth?.data.code == 200) {
          return next();
        } else {
          console.log("登录态失效，开始重新授权1");
        }
      } catch (e) {
        sessionStorage.removeItem("auth_token");
      }
    }

    const urlParams = new URLSearchParams(window.location.search);
    const wxCode = urlParams.get("code");

    // 没有有效code时才触发授权跳转，避免重复跳转
    if (!wxCode) {
      const currentFullUrl = window.location.origin + window.location.pathname;
      const redirectUri = encodeURIComponent(currentFullUrl);
      const appid = "wxb2a331b3ebb50c22";
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=${Date.now()}&connect_redirect=1#wechat_redirect`;
    } else {
      const authRes = await wxAuthLogin(wxCode);
      if (authRes?.data?.code === 200) {
        sessionStorage.setItem("auth_token", authRes.data.data.token);
        next()
      } else {
        next()
      }
    }
  } else {
    next();
  }
});
